const cloneElementWithoutAttributes = ({
  element
}) => {
  const clonedNode = element.cloneNode(true);
  const attributes = Array.from(clonedNode.attributes);
  attributes.forEach((attribute) => {
    const name = attribute.name;
    if (name !== "href") {
      clonedNode.removeAttribute(name);
    }
  });
  return clonedNode;
};
export {
  cloneElementWithoutAttributes
};
//# sourceMappingURL=cloneElementWithoutAttributes.js.map
